<script>
import modal from '@/components/view/modal'

export default {
  components: {
    'gp-modal': modal
  },
  props: {
    staffId: {
      type: String,
      required: true
    }
  },
  computed: {
    staff () {
      let docs

      if (this.$route.meta.version === 'raz') {
        docs = this.docs.razstaff
      } else {
        docs = this.docs.staff
      }

      return docs[this.staffId]
    }
  }
}
</script>

<template>
  <gp-modal>
    <div class="gp-staff-article">
      <article class="level">
        <div v-if="staff.image">
          <figure>
            <img :src="staff.image" alt="staff.name">
          </figure>
        </div>
        <div class="content">
          <div class="title is-size-0-mobile has-text-weight-bold">{{ staff.title }}</div>
          <h1 class="name">
            <span class="has-text-weight-bold">{{ staff.name }}</span>
          </h1>
          <div class="comment is-size-4 is-size-5-mobile" v-html="staff.comment"></div>
        </div>
      </article>
    </div>
  </gp-modal>
</template>

<style lang="scss" scoped>
.gp-staff-article {
  background: #BBE63F;
  background: rgba(187, 230, 63, .95);
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  * {
    pointer-events: auto;
  }
  article {
    margin: 1.5rem;
    @include is-mobile {
      margin: 4rem 1.5rem;
    }
    .content {
      @include is-not-mobile {
        max-width: 40rem;
      }
    }
    figure {
      @include is-mobile {
        width: 9.375rem;
        margin: auto;
        margin-bottom: 1.5rem;
      }
      @include is-not-mobile {
        width: 18.75rem;
        margin-right: 3rem;
      }
    }
    .title {
      @include is-mobile {
        line-height: 2.25rem;
      }
      @include is-not-mobile {
        line-height: 2.25rem;
        font-size: 1.875rem;
      }
    }
    .name {
      margin-top: .5rem;
      margin-bottom: 2rem;
      span {
        background-color: $black;
        color: $pink;
        @include is-mobile {
          font-size: 2.5rem;
          padding: 0 .75rem;
        }
        @include is-not-mobile {
          font-size: 3.125rem;
          padding: 0 1rem;
        }
      }
    }
    .comment {
      @include is-not-mobile {
        line-height: 28px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/staff/staff-article.vue